import { apiFailureMessage } from '@acies/platform';
import { Effect } from 'effect';
import type { CreateCalculationError } from './calculations';
import type { CreateConfigurationError, CreateConfigurationFromError } from './configurations';

/** Everything a call made for a position can fail with: configuring it, configuring it again with an answer changed, and pricing it. */
export type PositionCallError = CreateCalculationError | CreateConfigurationError | CreateConfigurationFromError;

/**
 * What to tell the user about a call made for a position that failed, in one sentence.
 *
 * The three failures that are the Configurator's own are given their sentence here, and everything else is the client's — see `apiFailureMessage`, which is where a refusal is answered in the API's own words. Exhaustive the same way: a failure added to one of the unions has to be given a sentence before it compiles,
 * since the default is typed as what is left once these three are taken out.
 *
 * What a position carries as its `error`, and so what both places that show one show — see `ModelPosition.error`.
 */
export function failureMessage(error: PositionCallError): Effect.Effect<string> {
	switch (error._tag) {
		case 'HttpBodyError':
			return Effect.succeed('Forespørgslen kunne ikke dannes.');
		case 'TimeoutError':
			return Effect.succeed('Motoren svarede ikke i tide.');
		case 'UnconfiguredPositionError':
			return Effect.succeed('Positionen er ikke konfigureret.');
		default:
			return apiFailureMessage(error);
	}
}
